import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_cashbook_txn_stmt_recon_link_RowClass
} from '../../../dbschema/index';

export class CashbookTxnBankStmtLinkContainer extends BaseContainerModel {
  bl_fi_cashbook_txn_stmt_recon_link: bl_fi_cashbook_txn_stmt_recon_link_RowClass = new bl_fi_cashbook_txn_stmt_recon_link_RowClass();

}
